export const registrationSlugs = ['basic-details', 'location', 'education', 'employment', 'create-account'];
